import React, { useState, useEffect } from 'react';
import { useMotionValue, useTransform, useSpring, useReducedMotion } from 'motion/react';

interface UseTiltOptions {
  strength?: number;
}

export function useTilt({ strength = 6 }: UseTiltOptions = {}) {
  const prefersReducedMotion = useReducedMotion();
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    setIsTouchDevice(
      window.matchMedia('(pointer: coarse)').matches ||
      'ontouchstart' in window
    );
  }, []);

  const isDisabled = !!prefersReducedMotion || isTouchDevice;

  const mouseX = useMotionValue(0.5);
  const mouseY = useMotionValue(0.5);

  const springConfig = { stiffness: 200, damping: 25 };

  const rotateX = useSpring(
    useTransform(mouseY, [0, 1], [strength, -strength]),
    springConfig,
  );
  const rotateY = useSpring(
    useTransform(mouseX, [0, 1], [-strength, strength]),
    springConfig,
  );

  function handleMouseMove(e: React.MouseEvent<HTMLElement>) {
    if (isDisabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    mouseX.set((e.clientX - rect.left) / rect.width);
    mouseY.set((e.clientY - rect.top) / rect.height);
  }

  function handleMouseLeave() {
    mouseX.set(0.5);
    mouseY.set(0.5);
  }

  return {
    rotateX: isDisabled ? undefined : rotateX,
    rotateY: isDisabled ? undefined : rotateY,
    handleMouseMove,
    handleMouseLeave,
    isDisabled,
  };
}
